namespace SorAraBul.Membership {
    export interface ProfileUpdateRequest extends Serenity.ServiceRequest {
        MobilePhoneNumber?: string;
        InvoiceAddress?: string;
    }
}

